import React, { useEffect, useMemo, useState } from "react";
import Page from "components/Page";
import styles from "../../Preferences/Preferences.module.scss";
import { withTranslation } from "react-i18next";
import constants from "./../../../../constants";
import { decodeId, encodeId } from "utils";
import Text from "components/Text";
import ToggleSwitch from "components/ToggleSwitch";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import SelectStaffMemberModal from "accountOwner/pages/AddEvent/components/SelectStaffMemberModal";
import { useSelector } from "react-redux";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  useOfficeDetail,
  useOfficeTimesheetSubmissionSelectedStaff,
  useUpdateTimesheetSubmissionMutation,
  useUpdateTimesheetSubmissionSelectedStaffMutation,
} from "repositories/office-repository";
import toast from "react-hot-toast";

function TimesheetSubmissionPreferences({ history, match, t, location }) {
  const officeId = decodeId(match.params.officeId);
  const profile = useSelector((state) => state.userProfile.profile);
  const loggedInUserId = useMemo(
    () => location?.state?.getDetailsOwnerIfStaff ?? profile?.id,
    [location?.state?.getDetailsOwnerIfStaff, profile?.id]
  );
  const {
    mutateAsync: updateTimesheetSubmissionPreferenceToggle,
    isLoading: updateTimesheetSubmissionLoading,
  } = useUpdateTimesheetSubmissionMutation();
  const { data, isFetching, isLoading, refetch } =
    useOfficeTimesheetSubmissionSelectedStaff(officeId, {
      enabled: !!officeId,
    });
  const { mutateAsync: staffSelectedSubmission, isLoading: isUpdateLoading } =
    useUpdateTimesheetSubmissionSelectedStaffMutation();
  const {
    data: officeData,
    isFetching: officeisFetching,
    isLoading: officeisLoading,
  } = useOfficeDetail(officeId);

  const [switchOnOff, setSwitchOnOff] = useState(false);
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);
  const [userIds, setUserIds] = useState([]);
  const [isSelectStaffMemberModalOpen, setIsSelectStaffMemberModalOpen] =
    useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };
  useEffect(() => {
    if (officeData?.isTimesheetEnabledForShift) {
      setSwitchOnOff(officeData?.isTimesheetEnabledForShift);
    }
  }, [officeData?.isTimesheetEnabledForShift]);
  useEffect(() => {
    if (data?.data) {
      setUserIds(
        data?.data.map((office) => ({
          ...office,
          id: office.officeId,
          name: office.officeName,
          externalId: office.id,
          isDeleted: false,
          isFromDetail: true,
        }))
      );
    }
  }, [data?.data]);
  const submiSelectedStaff = async () => {
    const existingUnselected = data?.data?.length
      ? data?.data
          ?.filter((res) => userIds.every((user) => user.userId !== res.userId))
          .map((res) => ({ ...res, isDeleted: true }))
      : [];
    const res = await staffSelectedSubmission({
      officeId,
      ShiftTimesheetEnabledUserList: [...userIds, ...existingUnselected].map(
        (user) => ({
          id: user?.externalId ?? user?.id,
          userId: user.userId,
          isDeleted: user.isDeleted,
        })
      ),
    });
    if (res.statusCode === 200) {
      toast.success(t("accountOwner.timesheetSubmission"));
      refetch();
    } else if (res?.message) {
      toast.error(res?.message);
    }
  };

  const displayUsers = useMemo(
    () => userIds?.filter((e) => !e?.isDeleted),
    [userIds]
  );
  return (
    <Page
      onBack={() =>
        history.push({
          pathname: constants.routes.accountOwner.timelinePreferences.replace(
            ":officeId",
            encodeId(officeId)
          ),
          state: { officeName: location?.state?.officeName },
        })
      }
      isTitleLoading={false}
      title={t("accountOwner.timesheetSubmissionPreferences")}
    >
      {location?.state?.officeName && (
        <div className="d-flex flex-column manage-schedule-heading title  mb-4">
          <p className="pms_subtitle">{location?.state?.officeName}</p>
        </div>
      )}

      <div className={styles["card"] + " " + "margin30"}>
        <div className={styles["accordion"]}>
          <div className="d-flex justify-content-between ">
            <Text color="#587E85" size="16px" weight="600">
              {t(
                `accountOwner.${
                  switchOnOff
                    ? "allowSubmissionTimesheetSubmissionPreferences"
                    : "enableSubmissionTimesheetSubmissionPreferences"
                }`
              )}
            </Text>
            <ToggleSwitch
              label="bill-me-later-toggle-dashboard"
              value={switchOnOff}
              disabled={
                updateTimesheetSubmissionLoading ||
                officeisFetching ||
                officeisLoading
              }
              onChange={async (e) => {
                const res = await updateTimesheetSubmissionPreferenceToggle({
                  officeId,
                  IsTimesheetEnabledForShift: e.target.checked,
                });

                if (res.statusCode === 200) {
                  setSwitchOnOff(!switchOnOff);
                }
              }}
            />
          </div>
          {switchOnOff && (
            <div
              className={
                styles.preferences_width +
                " " +
                "c-field position-relative mb-0 " + " " + "mt-20"
              }
            >
              <div className={" d-flex justify-content-between "}>
                <label className={styles["c-field-label"]}>
                  <span>{t("accountOwner.staffTxt")}</span>
                </label>
                <span
                  className={`${styles.link_new} link-btn`}
                  onClick={() => {
                    setIsSelectStaffMemberModalOpen(true);
                  }}
                >
                  {t("accountOwner.selectStaff")}
                </span>
              </div>

              <div className="c-form-control" style={{ position: "relative" }}>
                {displayUsers?.length === 0 ? (
                  <span>{t("accountOwner.noStaffSelected")}</span>
                ) : (
                  <MoreTagsFunction
                    value={displayUsers}
                    styles={styles.link_new}
                    clickHandler={(e) =>
                      handlePopupToggle(e, setInvitePopupOpen)
                    }
                    mapFn={(member) =>
                      member?.user?.fullName ||
                      [member?.user?.firstName, member?.user?.lastName]
                        .filter(Boolean)
                        .join(" ")
                    }
                  />
                )}
              </div>
              {invitePopupOpen && (
                <InviteesPopup
                  position={invitePopupPosition}
                  handleInvitePopupToggle={(e) =>
                    handlePopupToggle(e, setInvitePopupOpen)
                  }
                  list={userIds}
                  showRoleAndOffice={true}
                  isForEvent={true}
                />
              )}
            </div>
          )}
        </div>
        {switchOnOff && (
          <button
            className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-4"
            title={t("accountOwner.addEmployees")}
            onClick={submiSelectedStaff}
            disabled={isFetching || isLoading || isUpdateLoading || displayUsers?.length === 0}
          >
            {t("Save")}
          </button>
        )}
      </div>
      {isSelectStaffMemberModalOpen && (
        <SelectStaffMemberModal
          isOpen={isSelectStaffMemberModalOpen}
          closeStepOneModal={setIsSelectStaffMemberModalOpen}
          ownerId={loggedInUserId}
          setMemberIds={setUserIds}
          memberIds={userIds}
          eventOrShiftTab={false}
          officeId={officeId}
        />
      )}
    </Page>
  );
}

export default withTranslation()(TimesheetSubmissionPreferences);
